import { emojiCandidatePattern } from "./emojiRegexpPatterns";
import emojiMap from "./generated/emoji.json";
import type { EmojiItem } from "./types";

type SplitEmojisResult = Array<Record<"token" | "url", string>>;
export const splitEmojis = (text: string, customEmojis: ReadonlyArray<EmojiItem>): SplitEmojisResult => {
  const customEmojiMap = new Map(customEmojis.map((x) => [`:${x.name}:`, x.src]));
  return text.split(emojiCandidatePattern(customEmojis)).map((token) => {
    const url = customEmojiMap.get(token) || emojiMap[token] || "";
    return { token, url };
  });
};
